module.exports = __webpack_public_path__ + "static/media/kp.07ebeb5c.svg";